import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Password } from 'primereact/password';
import { Toast } from 'primereact/toast';
import { useRef } from 'react';

export const ModalPassword = ({ isAuthenticated, setIsAuthenticated }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const toast = useRef(null);

    useEffect(() => {
        // Siempre intentar verificar la contraseña del localStorage al iniciar
        const storedPassword = localStorage.getItem('backend_password');
        if (storedPassword && !isAuthenticated) {
            // Verificar la contraseña almacenada automáticamente
            verifyPassword(storedPassword, true);
        } else if (!storedPassword && !isAuthenticated) {
            // No hay contraseña almacenada, mostrar popup directamente
            setIsOpen(true);
        }
    }, [isAuthenticated]);

    const verifyPassword = async (passwordToVerify, isAutoVerification = false) => {
        setIsLoading(true);
        try {
            const url_server_local = 'https://olarra.ager-agro.es';
            const response = await fetch(url_server_local + '/api_olarra_chatbot/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ password: passwordToVerify }),
                cache: 'no-store'
            });
            if (response.status === 200) {
                // Contraseña correcta
                localStorage.setItem('backend_password', passwordToVerify);
                setIsAuthenticated(true);
                setIsOpen(false);
                
                // Solo mostrar mensaje de éxito si es verificación manual
                if (!isAutoVerification && toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Acceso concedido',
                        detail: 'Contraseña correcta. Bienvenido.',
                        life: 3000
                    });
                }
            } else {
                // Contraseña incorrecta
                localStorage.removeItem('backend_password');
                setIsAuthenticated(false);
                setIsOpen(true);
                
                // Mostrar mensaje de error apropiado
                if (toast.current) {
                    const errorMessage = isAutoVerification 
                        ? 'La contraseña almacenada ha expirado. Por favor, introduce la nueva contraseña.'
                        : 'Contraseña incorrecta. Inténtalo de nuevo.';
                    
                    toast.current.show({
                        severity: 'error',
                        summary: 'Acceso denegado',
                        detail: errorMessage,
                        life: 4000
                    });
                }
            }
        } catch (error) {
            console.error('Error al verificar contraseña:', error);
            localStorage.removeItem('backend_password');
            setIsAuthenticated(false);
            setIsOpen(true);
            
            if (toast.current) {
                const errorMessage = isAutoVerification 
                    ? 'No se pudo verificar la contraseña almacenada. Por favor, introduce tu contraseña.'
                    : 'No se pudo verificar la contraseña. Revisa tu conexión.';
                
                toast.current.show({
                    severity: 'error',
                    summary: 'Error de conexión',
                    detail: errorMessage,
                    life: 4000
                });
            }
        } finally {
            setIsLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!password.trim()) {
            toast.current.show({
                severity: 'warn',
                summary: 'Campo requerido',
                detail: 'Por favor, introduce una contraseña.',
                life: 3000
            });
            return;
        }

        await verifyPassword(password);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSubmit(e);
        }
    };

    return (
        <>
            <Toast ref={toast} />
            <Dialog
                visible={isOpen}
                style={{ width: '90vw', maxWidth: '400px' }}
                header="Acceso Requerido"
                modal
                closable={false}
                onHide={() => {}} // No permitir cerrar sin autenticación
                className="p-fluid"
            >
                <div className="p-1">
                    <div className="mb-4 text-center">
                        <i className="pi pi-lock" style={{ fontSize: '3rem', color: '#3d0090' }}></i>
                        <p className="mt-3 mb-0" style={{ color: '#666' }}>
                            Introduce la contraseña para acceder a la aplicación
                        </p>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="field">

                            <Password
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                onKeyPress={handleKeyPress}
                                placeholder="Contraseña"
                                feedback={false}
                                toggleMask
                                className="w-full"
                                inputStyle={{ width: '100%' }}
                                disabled={isLoading}
                                autoFocus
                            />
                        </div>
                        
                        <div className="mt-4">
                            <Button
                                label={isLoading ? 'Verificando...' : 'Acceder'}
                                icon={isLoading ? 'pi pi-spin pi-spinner' : 'pi pi-check'}
                                className="w-full"
                                type="submit"
                                disabled={isLoading}
                                style={{ 
                                    backgroundColor: '#3d0090',
                                    borderColor: '#3d0090'
                                }}
                            />
                        </div>
                    </form>
                </div>
            </Dialog>
        </>
    );
};